import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { SessionProvider } from "./lib/session";
import { ThemeProvider } from "./lib/theme";
import { ToastProvider } from "./lib/toast";

import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/code.css";
import "./styles/app.css";
import "./styles/lab.css";
import "./styles/admin.css";

const container = document.getElementById("root");
if (!container) throw new Error("The page is missing its #root element");

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <BrowserRouter>
          <SessionProvider>
            <App />
          </SessionProvider>
        </BrowserRouter>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
);
